/* ============================================================
   HFO - PRODUCT PAGE CARD SIBLINGS V4 FAST

   Used for:
   - You May Also Like
   - Product Recommendations
   - Recently Viewed

   PERFORMANCE:
   - Shares 6-hour card cache with Collection/Search
   - Restores cache immediately into newly created cards
   - Prefetches hidden recommendation template products
   - Lightweight sibling resolver
   - Pages 2+ requested in parallel
   - Candidate rendered immediately as each page returns
   - Highest/newest Metaobject ID always wins
   ============================================================ */

(function () {
  'use strict';


  if (
    !/\/products\/[^/]+\/?$/i.test(
      window.location.pathname
    )
  ) {
    return;
  }


  if (
    window.HFOProductCardSiblingFastV4Installed
  ) {
    return;
  }

  window.HFOProductCardSiblingFastV4Installed =
    true;



  /* ==========================================================
     SETTINGS
     ========================================================== */

  var CACHE_TTL =
    6 * 60 * 60 * 1000;


  /*
   * SAME cache as Collection/Search.
   */
  var CARD_CACHE_PREFIX =
    'hfoSiblingCardV4:';


  var WINNER_CACHE_PREFIX =
    'hfoSiblingWinnerV2:';


  var currentScript =
    document.currentScript;


  var siblingSwatchesSrc = '';

  var resolverBase =
    '/search';


  if (currentScript) {
    siblingSwatchesSrc =
      currentScript.getAttribute(
        'data-sibling-swatches-src'
      ) || '';


    resolverBase =
      currentScript.getAttribute(
        'data-sibling-resolver-url'
      ) ||
      resolverBase;
  }


  var scanRunning = false;
  var scanAgain = false;
  var scanTimer = null;


  /*
   * Network verification cache for this page session.
   * Live cards can still restore localStorage after being
   * dynamically inserted.
   */
  var networkVerified =
    Object.create(null);



  /* ==========================================================
     HELPERS
     ========================================================== */

  function cssEscape(value) {
    value = String(value);

    if (
      window.CSS &&
      typeof window.CSS.escape ===
      'function'
    ) {
      return window.CSS.escape(value);
    }

    return value.replace(
      /[^a-zA-Z0-9_-]/g,
      '\\$&'
    );
  }


  function normalizeEntryId(value) {
    value =
      String(value || '0')
        .replace(/\D/g, '')
        .replace(/^0+/, '');

    return value || '0';
  }


  function compareEntryIds(
    a,
    b
  ) {
    a = normalizeEntryId(a);
    b = normalizeEntryId(b);

    if (a.length > b.length) {
      return 1;
    }

    if (a.length < b.length) {
      return -1;
    }

    if (a === b) {
      return 0;
    }

    return a > b ? 1 : -1;
  }


  function now() {
    return Date.now();
  }



  /* ==========================================================
     STORAGE
     ========================================================== */

  function readLocal(key) {
    try {
      var raw =
        localStorage.getItem(key);

      if (!raw) {
        return null;
      }

      var data =
        JSON.parse(raw);

      if (
        !data ||
        !data.savedAt ||
        (
          now() - data.savedAt >
          CACHE_TTL
        )
      ) {
        localStorage.removeItem(key);
        return null;
      }

      return data;

    } catch (error) {
      return null;
    }
  }


  function writeLocal(
    key,
    data
  ) {
    try {
      data.savedAt = now();

      localStorage.setItem(
        key,
        JSON.stringify(data)
      );
    } catch (error) {
      /*
       * Ignore localStorage errors.
       */
    }
  }


  function getCardCache(
    productId
  ) {
    return readLocal(
      CARD_CACHE_PREFIX +
      String(productId)
    );
  }


  function setCardCache(
    productId,
    result
  ) {
    if (!result) {
      return;
    }

    writeLocal(
      CARD_CACHE_PREFIX +
      String(productId),
      {
        entryId:
          normalizeEntryId(
            result.getAttribute(
              'data-sibling-entry-id'
            ) || '0'
          ),

        html:
          result.outerHTML
      }
    );
  }


  function setWinnerMeta(
    productId,
    candidate
  ) {
    if (!candidate) {
      return;
    }

    writeLocal(
      WINNER_CACHE_PREFIX +
      String(productId),
      {
        entryId:
          normalizeEntryId(
            candidate.entryId
          ),

        page:
          Number(
            candidate.page || 1
          ),

        count:
          Number(
            candidate.count || 0
          ),

        handle:
          String(
            candidate.handle || ''
          )
      }
    );
  }



  /* ==========================================================
     SIBLING SCRIPT
     ========================================================== */

  function ensureSiblingScript() {
    if (
      window.customElements &&
      customElements.get(
        'sibling-swatches'
      )
    ) {
      return;
    }

    if (
      document.querySelector(
        'script[data-hfo-sibling-swatches-script]'
      )
    ) {
      return;
    }

    if (!siblingSwatchesSrc) {
      return;
    }


    var script =
      document.createElement(
        'script'
      );

    script.src =
      siblingSwatchesSrc;

    script.defer = true;

    script.setAttribute(
      'data-hfo-sibling-swatches-script',
      ''
    );

    document.head.appendChild(
      script
    );
  }



  /* ==========================================================
     RECOMMENDATION ROOT
     ========================================================== */

  function getRoot() {
    return document.querySelector(
      'type-first-related-products'
    );
  }


  function getHosts(
    productId
  ) {
    var root =
      getRoot();

    if (!root) {
      return [];
    }

    return root.querySelectorAll(
      '[data-hfo-grid-sibling-host]' +
      '[data-product-id="' +
      cssEscape(
        String(productId)
      ) +
      '"]'
    );
  }



  /* ==========================================================
     CARD HELPERS
     ========================================================== */

  function removeRegularSwatches(
    host
  ) {
    if (!host) {
      return;
    }

    var card =
      host.closest(
        '[data-product-block]'
      );

    if (!card) {
      return;
    }

    var fields =
      card.querySelectorAll(
        '[data-grid-swatch-fieldset]'
      );


    for (
      var i = 0;
      i < fields.length;
      i++
    ) {
      if (
        !host.contains(fields[i])
      ) {
        fields[i].remove();
      }
    }
  }


  function getCurrentResult(host) {
    if (!host) {
      return null;
    }

    return (
      host.querySelector(
        ':scope > [data-hfo-grid-sibling-result]'
      ) ||
      host.querySelector(
        '[data-hfo-grid-sibling-result]'
      )
    );
  }


  function getResultEntryId(result) {
    if (!result) {
      return '0';
    }

    return normalizeEntryId(
      result.getAttribute(
        'data-sibling-entry-id'
      ) || '0'
    );
  }



  /* ==========================================================
     PREPARE RESULT
     ========================================================== */

  function prepareResult(
    source,
    productId
  ) {
    if (!source) {
      return null;
    }


    productId =
      String(productId);


    var result =
      source.cloneNode(true);


    result.setAttribute(
      'data-product-id',
      productId
    );


    var links =
      result.querySelectorAll(
        '[data-sibling-product-id]'
      );


    var currentLink = null;


    for (
      var i = 0;
      i < links.length;
      i++
    ) {
      var link = links[i];


      link.removeAttribute(
        'aria-current'
      );


      var checks =
        link.querySelectorAll(
          '.icon-check'
        );


      for (
        var c = 0;
        c < checks.length;
        c++
      ) {
        if (checks[c].parentNode) {
          checks[c].parentNode.removeChild(
            checks[c]
          );
        }
      }


      var siblingId =
        String(
          link.getAttribute(
            'data-sibling-product-id'
          ) || ''
        );


      if (
        siblingId === productId
      ) {
        currentLink = link;
      }
    }



    if (currentLink) {
      currentLink.setAttribute(
        'aria-current',
        'true'
      );


      var component =
        result.querySelector(
          'sibling-swatches'
        );


      if (component) {
        var productUrl =
          currentLink.getAttribute(
            'href'
          ) || '';


        var productImage =
          currentLink.getAttribute(
            'data-sibling-featured-image-url'
          ) || '';


        if (productUrl) {
          component.setAttribute(
            'data-product-url',
            productUrl
          );
        }


        if (productImage) {
          component.setAttribute(
            'data-product-image',
            productImage
          );
        }
      }


      var usesImage =
        currentLink.classList.contains(
          'siblings__swatch--image'
        );


      var soldOut =
        currentLink.classList.contains(
          'siblings__swatch--sold-out'
        );


      if (
        !usesImage &&
        !soldOut
      ) {
        var tooltip =
          currentLink.querySelector(
            'tooltip-component'
          );


        if (
          tooltip &&
          !tooltip.querySelector(
            '.icon-check'
          )
        ) {
          var check =
            document.createElement(
              'span'
            );

          check.className =
            'icon icon-check';


          tooltip.insertBefore(
            check,
            tooltip.firstChild
          );
        }
      }
    }


    return result;
  }



  /* ==========================================================
     INSERT RESULT
     ========================================================== */

  function insertResult(
    productId,
    source
  ) {
    var hosts =
      getHosts(productId);


    if (
      !hosts.length ||
      !source
    ) {
      return false;
    }


    var candidateId =
      getResultEntryId(source);


    var inserted = false;


    for (
      var i = 0;
      i < hosts.length;
      i++
    ) {
      var host = hosts[i];


      var current =
        getCurrentResult(host);


      var currentId =
        current
          ? getResultEntryId(current)
          : normalizeEntryId(
              host.getAttribute(
                'data-hfo-selected-sibling-entry-id'
              ) || '0'
            );


      if (
        current &&
        currentId !== '0' &&
        compareEntryIds(
          candidateId,
          currentId
        ) <= 0
      ) {
        continue;
      }


      var prepared =
        prepareResult(
          source,
          productId
        );


      if (!prepared) {
        continue;
      }


      removeRegularSwatches(
        host
      );


      if (
        current &&
        current.parentNode === host
      ) {
        host.replaceChild(
          prepared,
          current
        );
      } else {
        var placeholder =
          host.querySelector(
            '[data-hfo-grid-sibling-placeholder]'
          );


        if (placeholder) {
          host.insertBefore(
            prepared,
            placeholder
          );
        } else {
          host.appendChild(
            prepared
          );
        }
      }


      host.setAttribute(
        'data-hfo-selected-sibling-entry-id',
        candidateId
      );


      inserted = true;
    }


    if (inserted) {
      ensureSiblingScript();
    }


    return inserted;
  }



  /* ==========================================================
     CACHE RESTORE
     ========================================================== */

  function restoreCacheForProduct(
    productId
  ) {
    var cached =
      getCardCache(productId);


    if (
      !cached ||
      !cached.html
    ) {
      return false;
    }


    var doc =
      new DOMParser()
        .parseFromString(
          cached.html,
          'text/html'
        );


    var result =
      doc.querySelector(
        '[data-hfo-grid-sibling-result]'
      );


    if (!result) {
      return false;
    }


    return insertResult(
      productId,
      result
    );
  }


  function restoreAllLiveCaches() {
    var root =
      getRoot();

    if (!root) {
      return;
    }


    var hosts =
      root.querySelectorAll(
        '[data-hfo-grid-sibling-host]' +
        '[data-product-id]'
      );


    var done =
      Object.create(null);


    for (
      var i = 0;
      i < hosts.length;
      i++
    ) {
      var id =
        String(
          hosts[i].getAttribute(
            'data-product-id'
          ) || ''
        );


      if (
        !id ||
        done[id]
      ) {
        continue;
      }


      done[id] = true;


      restoreCacheForProduct(
        id
      );
    }
  }



  /* ==========================================================
     COLLECT LIVE + HIDDEN TEMPLATE IDS
     ========================================================== */

  function collectProductIds() {
    var root =
      getRoot();


    var ids = [];
    var map =
      Object.create(null);


    if (!root) {
      return {
        ids: ids,
        map: map
      };
    }


    function addId(id) {
      id =
        String(
          id || ''
        ).trim();

      if (
        !id ||
        map[id] ||
        networkVerified[id]
      ) {
        return;
      }

      map[id] = true;

      ids.push(id);
    }


    var hosts =
      root.querySelectorAll(
        '[data-hfo-grid-sibling-host]' +
        '[data-product-id]'
      );


    for (
      var i = 0;
      i < hosts.length;
      i++
    ) {
      addId(
        hosts[i].getAttribute(
          'data-product-id'
        )
      );
    }


    /*
     * Product recommendation templates can exist
     * before cards are inserted into DOM.
     */
    var templates =
      root.querySelectorAll(
        'template'
      );


    for (
      var t = 0;
      t < templates.length;
      t++
    ) {
      var template =
        templates[t];


      addId(
        template.getAttribute(
          'data-product-id'
        )
      );


      if (!template.content) {
        continue;
      }


      var templateHosts =
        template.content.querySelectorAll(
          '[data-hfo-grid-sibling-host]' +
          '[data-product-id]'
        );


      for (
        var h = 0;
        h < templateHosts.length;
        h++
      ) {
        addId(
          templateHosts[h].getAttribute(
            'data-product-id'
          )
        );
      }
    }


    return {
      ids: ids,
      map: map
    };
  }



  /* ==========================================================
     RECENTLY VIEWED PREFETCH IDS
     ========================================================== */

  async function collectRecentlyViewedIds() {
    var handles = [];


    try {
      var stored =
        JSON.parse(
          localStorage.getItem(
            'theme:recently-viewed-products'
          ) || '[]'
        );


      if (
        Array.isArray(stored)
      ) {
        stored.forEach(
          function (item) {
            var handle = '';


            if (
              typeof item ===
              'string'
            ) {
              handle = item;

            } else if (
              item &&
              typeof item.handle ===
              'string'
            ) {
              handle =
                item.handle;
            }


            handle =
              String(
                handle || ''
              ).trim();


            if (
              handle &&
              !/^\d+$/.test(handle)
            ) {
              handles.push(handle);
            }
          }
        );
      }

    } catch (error) {
      return [];
    }


    handles =
      Array.from(
        new Set(handles)
      ).slice(
        0,
        12
      );


    if (!handles.length) {
      return [];
    }


    var root = '/';

    if (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    ) {
      root =
        Shopify.routes.root;
    }


    var products =
      await Promise.all(
        handles.map(
          function (handle) {
            return fetch(
              root +
              'products/' +
              encodeURIComponent(handle) +
              '.js',
              {
                credentials:
                  'same-origin'
              }
            )

              .then(
                function (response) {
                  if (!response.ok) {
                    return null;
                  }

                  return response.json();
                }
              )

              .catch(
                function () {
                  return null;
                }
              );
          }
        )
      );


    return products
      .filter(Boolean)
      .map(
        function (product) {
          return String(
            product.id || ''
          );
        }
      )
      .filter(Boolean);
  }



  /* ==========================================================
     CANDIDATE SELECTION
     ========================================================== */

  function chooseCandidate(
    bestCandidates,
    productId,
    candidate
  ) {
    var current =
      bestCandidates[
        productId
      ];


    if (!current) {
      bestCandidates[
        productId
      ] =
        candidate;

      return true;
    }


    var compare =
      compareEntryIds(
        candidate.entryId,
        current.entryId
      );


    if (
      compare > 0 ||
      (
        compare === 0 &&
        candidate.count >
          current.count
      )
    ) {
      bestCandidates[
        productId
      ] =
        candidate;

      return true;
    }


    return false;
  }



  /* ==========================================================
     PROCESS RESOLVER PAGE
     ========================================================== */

  function processResolverPage(
    html,
    requestedMap,
    bestCandidates,
    fallbackPage
  ) {
    if (!html) {
      return {
        valid: false,
        totalPages: 1,
        currentPage:
          fallbackPage || 1,
        pageParam: ''
      };
    }


    var doc =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    var resolver =
      doc.querySelector(
        '[data-hfo-sibling-resolver]'
      );


    if (!resolver) {
      return {
        valid: false,
        totalPages: 1,
        currentPage:
          fallbackPage || 1,
        pageParam: ''
      };
    }


    var pageInfo =
      doc.querySelector(
        '[data-hfo-resolver-page]'
      );


    var totalPages = 1;
    var currentPage =
      fallbackPage || 1;
    var pageParam = '';


    if (pageInfo) {
      totalPages =
        parseInt(
          pageInfo.getAttribute(
            'data-hfo-resolver-total-pages'
          ) || '1',
          10
        );


      currentPage =
        parseInt(
          pageInfo.getAttribute(
            'data-hfo-resolver-page'
          ) ||
          String(currentPage),
          10
        );


      pageParam =
        String(
          pageInfo.getAttribute(
            'data-hfo-resolver-page-param'
          ) || ''
        );
    }


    var templates =
      doc.querySelectorAll(
        'template[data-hfo-sibling-group]'
      );


    for (
      var i = 0;
      i < templates.length;
      i++
    ) {
      var template =
        templates[i];


      var idsString =
        String(
          template.getAttribute(
            'data-product-ids'
          ) || ''
        );


      if (
        !idsString ||
        !template.content
      ) {
        continue;
      }


      var groupIds =
        idsString.split(',');


      var source =
        template.content.querySelector(
          '[data-hfo-grid-sibling-result]'
        );


      if (!source) {
        continue;
      }


      var entryId =
        normalizeEntryId(
          template.getAttribute(
            'data-sibling-entry-id'
          ) ||
          source.getAttribute(
            'data-sibling-entry-id'
          ) ||
          '0'
        );


      var count =
        parseInt(
          template.getAttribute(
            'data-sibling-count'
          ) ||
          source.getAttribute(
            'data-sibling-count'
          ) ||
          String(groupIds.length),
          10
        ) || 0;


      var handle =
        String(
          template.getAttribute(
            'data-sibling-entry-handle'
          ) ||
          source.getAttribute(
            'data-sibling-entry-handle'
          ) ||
          ''
        );


      for (
        var x = 0;
        x < groupIds.length;
        x++
      ) {
        var productId =
          String(
            groupIds[x] || ''
          ).trim();


        if (
          !productId ||
          !requestedMap[productId]
        ) {
          continue;
        }


        var candidate = {
          entryId: entryId,
          count: count,
          handle: handle,
          page: currentPage,
          source:
            source.cloneNode(true)
        };


        if (
          chooseCandidate(
            bestCandidates,
            productId,
            candidate
          )
        ) {
          /*
           * Insert ASAP if card already exists.
           */
          insertResult(
            productId,
            candidate.source
          );


          /*
           * Prepare a card-specific cache even if card
           * has not been inserted into DOM yet.
           */
          var prepared =
            prepareResult(
              candidate.source,
              productId
            );


          if (prepared) {
            setCardCache(
              productId,
              prepared
            );
          }


          setWinnerMeta(
            productId,
            candidate
          );
        }
      }
    }


    return {
      valid: true,
      totalPages: totalPages,
      currentPage: currentPage,
      pageParam: pageParam
    };
  }



  /* ==========================================================
     FETCH RESOLVER PAGE
     ========================================================== */

  function fetchResolverPage(
    pageNumber,
    productIds,
    requestedMap,
    pageParam,
    bestCandidates
  ) {
    var url =
      new URL(
        resolverBase,
        window.location.origin
      );


    url.searchParams.set(
      'view',
      'hfo-siblings'
    );


    url.searchParams.set(
      'q',
      productIds.join(',')
    );


    if (
      pageNumber > 1 &&
      pageParam
    ) {
      url.searchParams.set(
        pageParam,
        String(pageNumber)
      );
    }


    url.searchParams.set(
      '_hfo_product_cards',
      'v4-fast'
    );


    return fetch(
      url.toString(),
      {
        method: 'GET',

        credentials:
          'same-origin',

        headers: {
          'X-Requested-With':
            'XMLHttpRequest'
        }
      }
    )

      .then(
        function (response) {
          if (!response.ok) {
            throw new Error(
              'HFO product card resolver HTTP ' +
              response.status
            );
          }

          return response.text();
        }
      )

      .then(
        function (html) {
          return processResolverPage(
            html,
            requestedMap,
            bestCandidates,
            pageNumber
          );
        }
      );
  }



  /* ==========================================================
     RESOLVE PRODUCT IDS
     ========================================================== */

  function resolveProductIds(
    productIds
  ) {
    productIds =
      Array.from(
        new Set(
          productIds
            .map(
              function (id) {
                return String(
                  id || ''
                ).trim();
              }
            )
            .filter(Boolean)
        )
      )

        .filter(
          function (id) {
            return !networkVerified[id];
          }
        );


    if (!productIds.length) {
      return Promise.resolve();
    }


    var requestedMap =
      Object.create(null);


    var bestCandidates =
      Object.create(null);


    for (
      var i = 0;
      i < productIds.length;
      i++
    ) {
      requestedMap[
        productIds[i]
      ] = true;


      /*
       * Cache first.
       */
      restoreCacheForProduct(
        productIds[i]
      );
    }


    return fetchResolverPage(
      1,
      productIds,
      requestedMap,
      '',
      bestCandidates
    )

      .then(
        function (firstPage) {
          if (
            !firstPage ||
            !firstPage.valid
          ) {
            return [];
          }


          if (
            firstPage.totalPages <= 1
          ) {
            return [];
          }


          if (!firstPage.pageParam) {
            console.warn(
              'HFO product cards: paginate.page_param missing.'
            );

            return [];
          }


          var requests = [];


          for (
            var page = 2;
            page <= firstPage.totalPages;
            page++
          ) {
            requests.push(
              fetchResolverPage(
                page,
                productIds,
                requestedMap,
                firstPage.pageParam,
                bestCandidates
              )
            );
          }


          return Promise.all(
            requests
          );
        }
      )

      .then(
        function () {
          for (
            var i = 0;
            i < productIds.length;
            i++
          ) {
            networkVerified[
              productIds[i]
            ] = true;


            /*
             * One last restore in case card appeared
             * while resolver requests were running.
             */
            restoreCacheForProduct(
              productIds[i]
            );
          }
        }
      );
  }



  /* ==========================================================
     RUN
     ========================================================== */

  async function runLookup() {
    if (scanRunning) {
      scanAgain = true;
      return;
    }


    var root =
      getRoot();

    if (!root) {
      return;
    }


    /*
     * Cached cards first = perceived instant display.
     */
    restoreAllLiveCaches();


    scanRunning = true;


    try {
      var collected =
        collectProductIds();


      var recentIds =
        await collectRecentlyViewedIds();


      var ids =
        Array.from(
          new Set(
            collected.ids.concat(
              recentIds
            )
          )
        );


      if (ids.length) {
        await resolveProductIds(
          ids
        );
      }


      restoreAllLiveCaches();

    } catch (error) {
      console.warn(
        'HFO product-card sibling lookup failed:',
        error
      );

    } finally {
      scanRunning = false;


      if (scanAgain) {
        scanAgain = false;

        setTimeout(
          runLookup,
          30
        );
      }
    }
  }



  /* ==========================================================
     SCHEDULER
     ========================================================== */

  function scheduleLookup() {
    clearTimeout(
      scanTimer
    );

    scanTimer =
      setTimeout(
        runLookup,
        20
      );
  }


  window.HFOProductCardSiblingRefresh =
    scheduleLookup;


  ensureSiblingScript();



  /* ==========================================================
     INITIAL RUN
     ========================================================== */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',

      function () {
        restoreAllLiveCaches();
        runLookup();
      },

      {
        once: true
      }
    );

  } else {
    restoreAllLiveCaches();
    runLookup();
  }


  setTimeout(
    function () {
      restoreAllLiveCaches();
      runLookup();
    },
    80
  );


  setTimeout(
    function () {
      restoreAllLiveCaches();
      runLookup();
    },
    300
  );


  setTimeout(
    function () {
      restoreAllLiveCaches();
      runLookup();
    },
    800
  );



  /* ==========================================================
     OBSERVER

     When recommendation/recent card is imported from a template,
     cached sibling HTML is inserted immediately.
     ========================================================== */

  var observer =
    new MutationObserver(
      function (mutations) {
        var shouldRun = false;


        for (
          var i = 0;
          i < mutations.length;
          i++
        ) {
          var nodes =
            mutations[i].addedNodes;


          for (
            var n = 0;
            n < nodes.length;
            n++
          ) {
            var node =
              nodes[n];


            if (
              !node ||
              node.nodeType !== 1
            ) {
              continue;
            }


            if (
              node.matches &&
              (
                node.matches(
                  '[data-hfo-grid-sibling-host][data-product-id]'
                ) ||
                node.matches(
                  'template[data-product-id]'
                ) ||
                node.matches(
                  'type-first-related-products'
                )
              )
            ) {
              shouldRun = true;
              break;
            }


            if (
              node.querySelector &&
              node.querySelector(
                '[data-hfo-grid-sibling-host][data-product-id], ' +
                'template[data-product-id], ' +
                'type-first-related-products'
              )
            ) {
              shouldRun = true;
              break;
            }
          }


          if (shouldRun) {
            break;
          }
        }


        if (shouldRun) {
          /*
           * Critical performance step.
           */
          restoreAllLiveCaches();

          scheduleLookup();
        }
      }
    );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );



  /* ==========================================================
     TABS
     ========================================================== */

  document.addEventListener(
    'click',

    function (event) {
      var target =
        event.target;


      if (
        !target ||
        !target.closest
      ) {
        return;
      }


      if (
        target.closest(
          '[data-tabs-link]'
        )
      ) {
        setTimeout(
          function () {
            restoreAllLiveCaches();
            scheduleLookup();
          },
          50
        );
      }
    }
  );



  /* ==========================================================
     BACK/FORWARD CACHE
     ========================================================== */

  window.addEventListener(
    'pageshow',

    function () {
      restoreAllLiveCaches();

      setTimeout(
        scheduleLookup,
        20
      );
    }
  );

})();